import { importProvidersFrom } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideOktaAuth, withOktaConfig } from '@okta/okta-angular';
import { AuthService } from '../auth.service';
import { oktaConfig } from './okta.config';
import { oktaRoutes } from './okta.routes';
import { OktaService } from './okta.service';

export const provideOktaCore = () => [
  { provide: AuthService, useClass: OktaService },
  provideOktaAuth(withOktaConfig(oktaConfig)),
  importProvidersFrom(RouterModule.forChild(oktaRoutes)),
];
